import { SyncOutlined } from "@ant-design/icons";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Button, Input, Layout, Menu, PageHeader, Popconfirm, Row, Table } from "antd";
import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";

import { EditStocks } from "./EditStocks";

const articleItemsQuery = gql`
  query ($pagination: ConnectionPagination, $searchQuery: String) {
    articleItems(pagination: $pagination, searchQuery: $searchQuery, stocked: true, includeVariants: true) {
      nodes {
        id
        code
        nameEn
        cover
        stocks {
          id
          quantity
          size {
            id
            code
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        page
        size
      }
      totalCount
      totalPages
    }
  }
`;

const magoSyncStocksMutation = gql`
  mutation {
    magoSyncStocks {
      successful
    }
  }
`;

export const List: React.FC<{}> = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");

  const variables = {
    pagination: { page: 1, pageSize: 0 },
    orderBy: { direction: "ASC", field: "ID" },
    searchQuery,
  };
  const { loading, data } = useQuery(articleItemsQuery, { variables });

  const handleSearch = (value: string) => setSearchQuery(value);
  const handleSearchCancel = () => setSearchQuery("");
  const handleTableChange = () => {};

  const [magoSyncStocks, { loading: syncLoading }] = useMutation(magoSyncStocksMutation, {});
  const [syncEnabled, setSyncEnabled] = useState(true);

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      width: "190px",
      render: (value: string, resource: any) => <NavLink to={`/global/items/${resource.id}`}>{value}</NavLink>,
    },

    {
      title: "Name",
      dataIndex: "nameEn",
      width: "190px",
    },
    {
      title: "Stocks",
      render: (resource: any) => <EditStocks resource={resource} />,
    },
  ];

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Row justify="space-between">
          <Menu theme="light" mode="horizontal">
            <Input.Search
              placeholder="search"
              onSearch={handleSearch}
              key={variables.searchQuery ?? "__search__"}
              defaultValue={variables.searchQuery ?? ""}
              style={{ width: 500, margin: "16px 30px" }}
              />
            <Button disabled={searchQuery.length === 0} onClick={handleSearchCancel} style={{ margin: "16px 0" }}>
              Cancel
            </Button>
          </Menu>
        </Row>
      </Layout.Header>
      <Layout className="content">
        <PageHeader
          ghost={true}
          title="Stocks"
          extra={
            <Popconfirm
              disabled={!syncEnabled}
              title="Are you sure?"
              icon={null}
              onConfirm={() => {
                magoSyncStocks();
                setSyncEnabled(false);
              }}
            >
              <Button loading={syncLoading} disabled={!syncEnabled}>
                <SyncOutlined />
                Mago Sync
              </Button>
            </Popconfirm>
          }
        />
        <Layout.Content className="content">
          <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={data?.articleItems.nodes}
            pagination={{
              hideOnSinglePage: true,
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range} of ${total}`,
              total: data?.totalCount ?? 0,
              defaultPageSize: 50,
            }}
            onChange={handleTableChange}
          />
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
